<template>
  <div
    class="info-block d-flex align-center px-3 py-1 mt-3"
    data-testid="tickets-ninety-days-banner"
  >
    <v-icon size="24" icon="$warning" />
    <span class="body2 ml-2" v-html="$t('tickets.ninetyDaysBanner')"></span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

// Ticket data lives in a 90-day window (PLAT-4257). Shown on every ticket log,
// on every tab, so the window is stated wherever tickets are listed.
export default defineComponent({});
</script>
